/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {genericCancelLastUserMessage} from '../api'

export const useMutationGenericCancelLastUserMessage = createReactQueryMutationHook('genericCancelLastUserMessage', genericCancelLastUserMessage)
